import s from './index.module.css';
import bg from './bg_septal_line.png';

// 带有下彩色边线的title组件

interface IProps {
  title: string,
  customStyle: object,
}

function LineTitle(props: IProps) {
  const { customStyle } = props
  return (
    <h3
      className={s.title}
      style={{
        background: `url(${bg}) no-repeat bottom/100% 0.1rem  #fff`,
        ...customStyle,
      }}
    >{props.title || '订单信息'}</h3>
  )
}

LineTitle.defaultProps = {
  customStyle: {},
}


export default LineTitle
